import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { StorageHandlerService, UnSubscriber } from "@mobi-office-ui";

@Component({
    selector: "mobi-office-login",
    templateUrl: "./login.component.html",
    styleUrl: "./login.component.scss",
    standalone: false
})
export class LoginComponent extends UnSubscriber {
  constructor(
    private router: Router,
    private storageHandlerService: StorageHandlerService
  ) {
    super();
  }

  async onSignIn(res: any) {
    const { Token } = JSON.parse(JSON.stringify(res || {}));
    this.storageHandlerService.setItem("token", Token);

    this.router.navigate(["/dashboard"]);
  }
}
